import React from 'react';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_URL = "https://wa.me/919850206906?text=Hi%2C%20I%27d%20like%20to%20enroll%20my%20child%20in%20the%20AI%20Smart-Student%20Program.%20Please%20help%20me%20with%20the%20next%20steps.";

const WhatsAppButton: React.FC = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="hidden md:flex fixed bottom-6 right-4 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#20bd5a] rounded-full items-center justify-center shadow-lg shadow-[#25D366]/30 transition-transform hover:scale-110"
    >
      <MessageCircle className="w-7 h-7 text-white fill-white" />
    </a>
  );
};

export default WhatsAppButton;
